import React from 'react';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const ImagePreviewModal = ({
    visible,
    imageSrc,
    title,
    meta,
    onClose,
    onDownload,
    onCopyLink,
}) => {
    return (
        <Modal
        className='previewVisibleModal'
            open={visible}
            footer={null}
            onCancel={onClose}
            closable={false}
            centered
            width="100%"
            style={{ maxWidth: '100vw', height: '100vh', top: 0, padding: 0 }}
            mask={false}
            styles={{
                padding: 0,
                height: '100%',
                width: '100%',
                overflow: 'hidden',
                position: 'fixed',
                top: '0',
                left: '0'
            }}
        >
            <div
                onClick={onClose}
                style={{
                    backgroundColor: 'rgba(0,0,0,0.85)',
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div
                    onClick={(e) => e.stopPropagation()}
                    style={{ textAlign: 'center', color: '#fff', boxSizing: "border-box" }}
                >
                    <img alt="Preview" src={imageSrc} style={{ maxHeight: '80vh', maxWidth: '80vw' }} />
                    <div className='preview-popup-footer'>
                        <div style={{ fontSize: 12 }}>
                            <div>{title}</div>
                            <div style={{ marginTop: 4, color: '#ccc' }}>{meta}</div>
                        </div>
                        <button className='CopyLinkBnt' onClick={onCopyLink}>
                            Copy Link
                        </button>
                        <button
                            onClick={onDownload}
                            style={{
                                background: '#555',
                                border: 'none',
                                color: 'white',
                                padding: '6px 12px',
                                borderRadius: 4,
                                cursor: 'pointer'
                            }}
                        >
                            Download
                        </button>
                        <button className='preview-popup-close' onClick={onClose}>
                            <CloseOutlined />
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ImagePreviewModal;
